import { ZonedDateTime } from '@internationalized/date';
import {
  ActionType,
  AddressType,
  ServiceStatus,
} from '@rematter/frontend-lib-api-client';

import { SERVICE_FRAGMENT } from '../@shared-fragments/serviceFragment';
import { mapService } from '../@shared-mappers/mapService';
import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useUpdateServiceMutation = createMutationHook(
  'transportation.serviceUpdate',
  (params: {
    id: string;
    serviceTypeId?: string;
    status?: ServiceStatus;
    rank?: string;
    priority?: number;
    scheduledWindowStart?: ZonedDateTime;
    scheduledWindowEnd?: ZonedDateTime;
    internalNotes?: string;
    externalNotes?: string;
    driverNotes?: string;
    driverId?: string;
    haulerId?: string;
    truckId?: string;
    trailerId?: string;
    estimatedArrival?: ZonedDateTime;
    facilityGroupId?: string;
    facilityId?: string;
    accountId?: string;
    accountAddressId?: string;
    contactId?: string;
    routeId?: string;
    actions?: {
      actionType?: ActionType;
      assetTypeId: string;
      assetId?: string;
      quantity?: number;
      assetGroup?: number;
    }[];
    address?: {
      streetAddress: string;
      city: string;
      state: string;
      postalCode: string;
      country: string;
      addressType: AddressType;
      isMailingAddress: boolean;
      coordinates?: {
        latitude: number;
        longitude: number;
      };
    };
  }) => ({
    transportationServiceUpdate: {
      __args: {
        id: params.id,
        input: {
          serviceTypeId: params.serviceTypeId,
          status: params.status,
          rank: params.rank,
          priority: params.priority,
          facilityId: params.facilityId,
          contactId: params.contactId,
          scheduledWindowStart: params.scheduledWindowStart?.toAbsoluteString(),
          scheduledWindowEnd: params.scheduledWindowEnd?.toAbsoluteString(),
          internalNotes: params.internalNotes,
          externalNotes: params.externalNotes,
          driverNotes: params.driverNotes,
          driverId: params.driverId,
          haulerId: params.haulerId,
          truckId: params.truckId,
          trailerId: params.trailerId,
          estimatedArrival: params.estimatedArrival?.toAbsoluteString(),
          accountId: params.accountId,
          accountAddressId: params.accountAddressId,
          address: params.address,
          facilityGroupId: params.facilityGroupId,
          routeId: params.routeId,
          actions: params.actions,
        },
      },
      ...SERVICE_FRAGMENT,
    },
  }),
  {
    select: ({ transportationServiceUpdate: service }) => mapService(service),
    invalidateQueries: [useLoadBoardServicesQuery],
  },
);
